import { useState } from 'react';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { pdfjs } from 'react-pdf';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

import * as S from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
  devicePixelRatio: Math.min(2, window.devicePixelRatio),
};

const Manual = () => {
  const [file] = useState(
    `${window.location.hostname === 'localhost' ? 'http://' : 'https://'}${
      window.location.host
    }/pdf/manual.pdf`,
  );
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages: nextNumPages }: any) {
    setNumPages(nextNumPages);
  }

  return (
    <S.Container id="pdf-container">
      <Document
        file={file}
        loading={<p style={{ color: '#fff' }}>Carregando Documento</p>}
        onLoadSuccess={onDocumentLoadSuccess}
        renderMode="canvas"
        options={options}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    </S.Container>
  );
};

export default Manual;
